/* POTACIA — global behavior (minimal) */
document.addEventListener('DOMContentLoaded', () => {
  // Header transparency on scroll
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu toggle
  document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.querySelector(btn.dataset.menuToggle);
      if (target) target.classList.toggle('is-open');
      btn.classList.toggle('is-active');
    });
  });
});
